/* Collection toolbar: quick filter chips + filter-count badge. Chips are plain links built from Shopify's
   own storefront filter params (filter.v.availability, filter.v.price.gte/lte, sort_by), so they work with the
   theme's filter drawer and are crawlable-neutral (rel=nofollow). */
(function () {
  function init() {
    var bar = document.querySelector('#content form.f8sr > fieldset');
    if (!bar || bar.dataset.bbf) return; bar.dataset.bbf = '1';
    var here = new URL(window.location.href);
    var p = here.searchParams;
    function isOn(ch) {
      return Object.keys(ch.set).every(function (k) { return p.get(k) === ch.set[k]; }) &&
        (ch.unset || []).every(function (k) { return !p.has(k); });
    }
    function hrefFor(ch, on) {
      var u = new URL(here.href); u.searchParams.delete('page');
      (ch.clear || []).forEach(function (k) { u.searchParams.delete(k); });
      if (on) Object.keys(ch.set).forEach(function (k) { u.searchParams.delete(k); });
      else Object.keys(ch.set).forEach(function (k) { u.searchParams.set(k, ch.set[k]); });
      return u.pathname + (u.search || '');
    }
    var PRICE = ['filter.v.price.gte', 'filter.v.price.lte'];
    var chips = [
      { t: 'In stock', set: { 'filter.v.availability': '1' } },
      { t: 'Under $50', set: { 'filter.v.price.lte': '50' }, clear: PRICE, unset: ['filter.v.price.gte'] },
      { t: '$50–$100', set: { 'filter.v.price.gte': '50', 'filter.v.price.lte': '100' }, clear: PRICE },
      { t: '$100–$200', set: { 'filter.v.price.gte': '100', 'filter.v.price.lte': '200' }, clear: PRICE },
      { t: '$200+', set: { 'filter.v.price.gte': '200' }, clear: PRICE, unset: ['filter.v.price.lte'] },
      { t: 'Best selling', set: { 'sort_by': 'best-selling' }, sort: 1 },
      { t: 'Price ↑', set: { 'sort_by': 'price-ascending' }, sort: 1 },
      { t: 'Price ↓', set: { 'sort_by': 'price-descending' }, sort: 1 }
    ];
    var active = 0;
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && !(k === 'filter.v.price.gte' && v === '0')) active++; });
    var row = document.createElement('div');
    row.className = 'bbf';
    var html = '<a href="./" class="bbf__btn" data-panel="filters" aria-haspopup="true" aria-controls="filters">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>' +
      '<span>Filter &amp; sort</span>' + (active ? '<b class="bbf__n">' + active + '</b>' : '') + '</a><div class="bbf__chips" role="list">';
    chips.forEach(function (ch, i) {
      var on = isOn(ch);
      if (ch.sort && i === 5) html += '<span class="bbf__sep" aria-hidden="true"></span>';
      html += '<a role="listitem" rel="nofollow" class="bbf__chip' + (on ? ' is-on' : '') + '" href="' + hrefFor(ch, on) + '"' + (on ? ' aria-current="true"' : '') + '>' + ch.t + (on ? '<span class="bbf__x" aria-label="remove">×</span>' : '') + '</a>';
    });
    html += '</div>';
    row.innerHTML = html;
    bar.insertBefore(row, bar.firstChild);
    document.documentElement.classList.add('bbf-ready');
    // the theme binds [data-panel] on load; re-trigger its drawer through the original (hidden) link
    var orig = document.querySelector('#content form.f8sr a[data-panel="filters"]:not(.bbf__btn)') ||
               document.querySelector('a[data-panel="filters"]:not(.bbf__btn)');
    row.querySelector('.bbf__btn').addEventListener('click', function (e) {
      if (orig) { e.preventDefault(); orig.click(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
